import { StateType } from '../../index';

export const profileAchievementsReducerSelector = (state: StateType) => state.getIn(['profile', 'achievements']);
export const profileAchievementsIsFetchingSelector = (state: StateType) => state.getIn(['profile', 'achievements', 'isFetching']);
export const profileAchievementsAllSelector = (state: StateType) => state.getIn(['profile', 'achievements', 'all']);
export const profileAchievementsIncompleteSelector = (state: StateType) => state.getIn(['profile', 'achievements', 'incomplete']);
export const profileAchievementsCompletedSelector = (state: StateType) => state.getIn(['profile', 'achievements', 'completed']);
export const profileAchievementsFilterSelector = (state: StateType) => state.getIn(['profile', 'achievements', 'filter']);
